import api from './api';

export function listStaffAlerts(params = {}) {
  return api.get('/staff-alerts', { params });
}

export function getStaffAlertUnreadCount() {
  return api.get('/staff-alerts/unread-count');
}

export function markStaffAlertRead(id) {
  return api.put(`/staff-alerts/${encodeURIComponent(id)}/read`);
}

export function dismissStaffAlert(id) {
  return api.delete(`/staff-alerts/${encodeURIComponent(id)}`);
}

export function markAllStaffAlertsRead() {
  return api.put('/staff-alerts/read-all');
}

export function sendStaffAlertTest(payload = {}) {
  return api.post('/staff-alerts/test', payload);
}
